var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass:
        "config-group-outline px-prj2 py-prj px-3@large border mt-prj3",
    },
    [
      _c("div", { staticClass: "row my-children-2" }, [
        _c("div", { staticClass: "small-12 column" }, [
          _c(
            "div",
            { staticClass: "config-item__info d-inline-flex production-info" },
            [
              _c("h2", { staticClass: "h3 mt-0 mb-0" }, [
                _vm._v(
                  "\n                    " +
                    _vm._s(this.group.caption) +
                    "\n                "
                ),
              ]),
            ]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "row my-children-2" }, [
            _c("div", { staticClass: "small-12 column" }, [
              _vm.auflageId != "0" && _vm.produktionsverfahren.values.length
                ? _c(
                    "div",
                    {
                      staticClass:
                        "config-group-outline px-prj2 py-prj px-3@large border",
                    },
                    [
                      _vm._l(
                        _vm.produktionsverfahren.values,
                        function (optionValue, idx) {
                          return [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "config-item__info d-inline-flex flex-column py-prj2 py-prj3@large w-100",
                              },
                              [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.produktionVal,
                                      expression: "produktionVal",
                                    },
                                  ],
                                  attrs: {
                                    type: "radio",
                                    name: _vm.produktionsverfahren.id,
                                    id: optionValue.fullId,
                                  },
                                  domProps: {
                                    value: optionValue.id,
                                    checked: _vm._q(
                                      _vm.produktionVal,
                                      optionValue.id
                                    ),
                                  },
                                  on: {
                                    change: function ($event) {
                                      _vm.produktionVal = optionValue.id
                                    },
                                  },
                                }),
                                _vm._v(" "),
                                _c(
                                  "label",
                                  {
                                    staticClass:
                                      "label-aligned font-weight-bold",
                                    attrs: { for: optionValue.fullId },
                                  },
                                  [
                                    _c("span", { staticClass: "mainlabel" }, [
                                      _vm._v(_vm._s(optionValue.caption)),
                                    ]),
                                    _vm._v(" "),
                                    _c(
                                      "span",
                                      {
                                        staticClass:
                                          "font-weight-light font-italic d-block@until-large text-small@until-medium",
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.versandTermine[
                                              "produktionsdauer" +
                                                optionValue.id
                                            ]
                                          )
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "span",
                                      {
                                        staticClass:
                                          "font-weight-light font-italic d-block@until-large text-small@until-medium",
                                      },
                                      [_vm._v(_vm._s(optionValue.text))]
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _vm.produktionVal == optionValue.id
                                  ? _c(
                                      "ul",
                                      {
                                        staticClass:
                                          "config-item__list r-list mt-1 ml-3",
                                      },
                                      _vm._l(
                                        _vm.lieferart.values,
                                        function (lieferartValue) {
                                          return _vm.isLieferartVisible(
                                            lieferartValue.id
                                          )
                                            ? _c(
                                                "li",
                                                {
                                                  staticClass:
                                                    "border-bottom py-prj2",
                                                },
                                                [
                                                  _c("input", {
                                                    directives: [
                                                      {
                                                        name: "model",
                                                        rawName: "v-model",
                                                        value: _vm.lieferartVal,
                                                        expression:
                                                          "lieferartVal",
                                                      },
                                                    ],
                                                    attrs: {
                                                      type: "radio",
                                                      name: _vm.lieferart.id,
                                                      id:
                                                        _vm.lieferart.id +
                                                        "_" +
                                                        lieferartValue.id,
                                                    },
                                                    domProps: {
                                                      value: lieferartValue.id,
                                                      checked: _vm._q(
                                                        _vm.lieferartVal,
                                                        lieferartValue.id
                                                      ),
                                                    },
                                                    on: {
                                                      change: function (
                                                        $event
                                                      ) {
                                                        _vm.lieferartVal =
                                                          lieferartValue.id
                                                      },
                                                    },
                                                  }),
                                                  _vm._v(" "),
                                                  _c(
                                                    "label",
                                                    {
                                                      staticClass:
                                                        "label-aligned font-weight-bold",
                                                      attrs: {
                                                        for:
                                                          _vm.lieferart.id +
                                                          "_" +
                                                          lieferartValue.id,
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "mainlabel",
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              lieferartValue.caption
                                                            )
                                                          ),
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "font-weight-light d-block@until-large text-small@until-medium",
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.getPorto(
                                                                lieferartValue.id
                                                              )
                                                            )
                                                          ),
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      lieferartValue
                                                        .additionalValues
                                                        .infoText
                                                        ? _c("Tooltip", {
                                                            attrs: {
                                                              infoText:
                                                                lieferartValue
                                                                  .additionalValues
                                                                  .infoText,
                                                            },
                                                          })
                                                        : _vm._e(),
                                                    ],
                                                    1
                                                  ),
                                                  _vm._v(" "),
                                                  _vm.isVersandaufteilung(
                                                    lieferartValue.id
                                                  ) &&
                                                  _vm.isVersandaufteilung(
                                                    _vm.lieferartVal
                                                  )
                                                    ? [
                                                        _c(
                                                          "VersandaufteilungOverlay",
                                                          {
                                                            attrs: {
                                                              isCheckout: false,
                                                              isSelected:
                                                                _vm.isVersandaufteilung(
                                                                  _vm.lieferartVal
                                                                ),
                                                              addresses:
                                                                _vm.addresses,
                                                              "auflage-zahl":
                                                                _vm.individualAuflage,
                                                              belegexemplar:
                                                                _vm.belegexemplar,
                                                              productImageUrl:
                                                                _vm.globalConfig
                                                                  .productImageUrl,
                                                              productName:
                                                                _vm.globalConfig
                                                                  .product_name,
                                                            },
                                                          }
                                                        ),
                                                      ]
                                                    : _vm._e(),
                                                ],
                                                2
                                              )
                                            : _vm._e()
                                        }
                                      ),
                                      0
                                    )
                                  : _vm._e(),
                              ]
                            ),
                            _vm._v(" "),
                            idx < _vm.produktionsverfahren.values.length - 1
                              ? _c("hr", { staticClass: "m-0 bg-shade" })
                              : _vm._e(),
                          ]
                        }
                      ),
                    ],
                    2
                  )
                : _c("div", [
                    _c(
                      "div",
                      {
                        staticClass:
                          "text-small mt-prj text-error d-flex line-height-12",
                      },
                      [
                        _c(
                          "svg",
                          {
                            staticClass:
                              "mr-2 svg-icon flex-child-fix position-relative t-1px",
                            attrs: {
                              xmlns: "http://www.w3.org/2000/svg",
                              viewBox: "0 0 36 36",
                            },
                          },
                          [
                            _c("circle", {
                              attrs: {
                                cx: "18",
                                cy: "18",
                                r: "18",
                                fill: "#e94d47",
                              },
                            }),
                            _c("path", {
                              attrs: {
                                d: "M16.08 26.43c0-.3.05-.58.17-.85.11-.27.26-.5.46-.69.2-.19.43-.35.7-.46.27-.12.56-.17.86-.17.3 0 .58.06.85.17.27.12.5.27.69.46.19.19.34.42.46.69.12.27.17.55.17.85 0 .31-.06.59-.17.86-.12.26-.27.49-.46.68-.19.19-.42.34-.69.45a2.223 2.223 0 01-1.71 0c-.27-.11-.5-.26-.7-.45-.2-.19-.35-.42-.46-.68-.11-.27-.17-.55-.17-.86zm3.9-18.86v8.24c0 .87-.04 1.73-.13 2.57-.09.84-.2 1.73-.34 2.67h-2.4c-.14-.94-.26-1.83-.35-2.67-.09-.84-.13-1.7-.13-2.57V7.57h3.35z",
                                fill: "#fff",
                              },
                            }),
                          ]
                        ),
                        _vm._v(
                          "\n                            " +
                            _vm._s(
                              _vm._f("translate")("lblKeineAuflageGewaehlt")
                            ) +
                            "\n                        "
                        ),
                      ]
                    ),
                  ]),
            ]),
          ]),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }